export default /@livingsecurity\.com$/g;
